module.exports = __webpack_public_path__ + "static/media/27EA1E0B-0773-4C80-B610-C232B493F9DA.2c8cd8c9.bin";